import { render } from "./ClientOrders.vue?vue&type=template&id=6a05f381&scoped=true"
import script from "./ClientOrders.vue?vue&type=script&lang=js"
export * from "./ClientOrders.vue?vue&type=script&lang=js"

import "./ClientOrders.vue?vue&type=style&index=0&id=6a05f381&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a05f381"]])

export default __exports__